// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"340":"b65f8291","375":"68db2fc8","386":"8e9c997e","515":"8d17833b","642":"61b9e545","668":"6b259a7f"}[chunkId] + ".chunk.js";
};